import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetches the list of uploaded documents for a bulk upload entry.
 * GET api/BulkUpload/onboarding-document-list?bulkUploadId={id}
 */
export const fetchOnboardingDocumentListAction = async (bulkUploadId) => {
  try {
    const response = await apiClient.get(
      `${ATP_API_URL.ONBOARDING_DOCUMENT_LIST}?bulkUploadId=${bulkUploadId}`,
    );

    if (response?.status === 200 && response.data) {
      const { success, message, data } = response.data;
      return {
        success: !!success,
        data: data || [],
        message: message || "",
      };
    }
    return { success: false, data: [], message: "Failed to fetch documents" };
  } catch (error) {
    console.error("[FetchOnboardingDocumentList] error:", error);
    return {
      success: false,
      data: [],
      message:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch documents",
    };
  }
};
